import ShareSVG from "@design-system/ui-icons/vanilla/Share"
import { createIcon } from "../createIcon"

export const ShareIcon = createIcon(ShareSVG)
